import OrchestraIcon from "../../assets/icons/instruments/orchestraIcon";
import { getInstrument } from "../../data/instrumentManager";

import { InstrumentAmountDTOInstrumentEnum } from "../../openapi-generated-client";
import "./instrumentDisplay.css";

interface InstrumentDisplayProps {
    instrument: InstrumentAmountDTOInstrumentEnum;
    amount: number;
    small?: boolean;
    className?: string;
}

export default function InstrumentDisplay(props: InstrumentDisplayProps) {

    var ins = getInstrument(props.instrument);

    if(!ins) {
        return <div className={"instrument-display " + (props.className ?? "")}>
            <span>{props.amount > 1 ? props.amount : ""} Unknown Instrument</span>
        </div>;
    }

    if(props.small) {
        return <div className={"instrument-display small " + (props.className ?? "")}>
            <span>{props.amount > 1 ? props.amount : ""}</span>
            {ins.icon}
        </div>;
    }

    return <div className={"instrument-display " + (props.className ?? "")}>
        {ins.icon}
        <span>{props.amount > 1 ? props.amount : ""} {ins.name}</span>
    </div>;
}

export function OrchestraInstrumentDisplay() {
    return<div className="instrument-display">
        <OrchestraIcon/>
    </div>;
}